import { FormaExpandedTooltip } from '@/components/UI/FormaExpandedTooltip/FormaExpandedTooltip';
import styles from './styles.module.scss';
import { ViewScoreBreakdown } from '@/services/score/view';
import { ViewRecommendation } from './ViewRecommendation';

interface ViewBreakdownProps {
	id: string;
	scoreData: ViewScoreBreakdown;
}

interface ViewSection {
	label: string;
	score: number;
	maxScore: number;
}

export const ViewBreakdown = ({ id, scoreData }: ViewBreakdownProps) => {
	const sections: ViewSection[] = [
		{ label: 'Open', score: scoreData.openScore, maxScore: 30 },
		...(scoreData.beyondHorizonEnabled
			? [{ label: 'Beyond Horizon Bonus', score: scoreData.beyondHorizonBonus, maxScore: 12 }]
			: []),
		{ label: 'Vegetation', score: scoreData.vegetationScore, maxScore: 20 },
		{ label: 'Water', score: scoreData.waterScore, maxScore: 15 },
		{ label: 'Sky View', score: scoreData.skyViewFactor, maxScore: 10 },
		{ label: 'Diversity', score: scoreData.viewDiversity, maxScore: 7 },
		{ label: 'Horizontal', score: scoreData.horizontalOpenness, maxScore: 10 },
	];

	return (
		<FormaExpandedTooltip
			loadingduration={500}
			position="left"
			text="View Breakdown"
			targetId={id}
		>
			<div className={styles.scoreSummary}>
				<div className={styles.summaryTitle}>
					<strong>Total Score: {scoreData.totalScore.toFixed(1)}</strong>
				</div>

				<div className={styles.simpleRecommendation}>
					<ViewRecommendation scoreData={scoreData} />
				</div>

				<div className={styles.simpleTable}>
					{sections.map((section) => {
						const percentage = (section.score / section.maxScore) * 100;
						const color =
							percentage < 40
								? '#ef4444'
								: percentage < 70
									? '#f59e0b'
									: '#10b981';

						return (
							<div key={section.label} className={styles.tableRow}>
								<div className={styles.rowInfo}>
									<span className={styles.rowLabel}>{section.label}</span>
									<span className={styles.rowMeta}>
										{section.score.toFixed(1)} / {section.maxScore}
									</span>
								</div>
								<div className={styles.rowBarWrapper}>
									<div className={styles.simpleBarBg}>
										<div
											className={styles.simpleBarFill}
											style={{
												width: `${percentage}%`,
												backgroundColor: color,
											}}
										/>
									</div>
									<span className={styles.rowScore}>{section.score.toFixed(1)}</span>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</FormaExpandedTooltip>
	);
};
